import React from 'react'

export const LotteryStatus = ({ lotteryStatus }) => {
  return (
    <>
      {lotteryStatus == "LotteryWaiting" ?
        <span style={{ marginLeft: '10px', color: "#ffc107" }}>در انتظار قرعه کشی  </span> : <></>
      }
      {lotteryStatus == "LotteryCompleted" ?
        <span style={{ marginLeft: '10px', color: "#17a2b8" }}>قرعه کشی انجام شده  </span> : <></>
      }
      {lotteryStatus == "LotteryConfirmed" ?
        <span style={{ marginLeft: '10px', color: "#28a745" }}>قرعه کشی تایید شده  </span> : <></>
      }
    </>
  )
}
